/* eslint-disable no-undef */
import { useSelector } from 'react-redux';

export default function Pendo() {
  const { user } = useSelector((state) => state.auth);

  if (process.env.NODE_ENV !== 'development' && user && window.pendo) {
    window.pendo.initialize({
      visitor: {
        id: user?.id,
        email: user?.attributes?.email,
        full_name: `${user?.attributes?.name} ${user?.attributes?.surnames}`,
        language: user?.attributes?.locale
      },

      account: {
        id: user?.id
      }
    });
  }
}
